import {
	createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import installElementPlus from './plugins/element'
import './assets/css/icon.css'
import '../icon/iconfont.css'
// import BaiduMap from 'vue-baidu-map'
// require('./mock');

const app = createApp(App)
installElementPlus(app)
app
	.use(store)
	.use(router)
	// .use(BaiduMap, {
	//     ak: 'QFgFQorrB84maOZh0pPGC8kUiP0mGIhx'
	// })
	.mount('#app')
